import ERROR_DOMAIN from 'constants/errors';

const { MODULE_NOT_FOUND } = ERROR_DOMAIN;

export default function ModuleNotLoadedError() {
  return (
    <div className="body-content main-wrapper margin-top--xlarge width--100-percent">
      <div className="aligner--center--vertical aligner--center--horizontal">
        <h2>{MODULE_NOT_FOUND}</h2>
      </div>
    </div>
  );
}
